import React, { useContext } from 'react';

import { ModalManager } from 'ui-components/components/modal-manager';

import { Context } from './context';
import { MODAL_ROOT_CONTAINER } from '../constants/element-ids';

/**
 * @deprecated The legacy modal system portal. No longer needed when using `@mantine/modals`. See docs/mantine-modals.md.
 */
const ModalManagerPortal = () => {
  const { setModalManagerRef } = useContext(Context);

  return (
    <div id={MODAL_ROOT_CONTAINER} ref={setModalManagerRef}>
      <ModalManager />
    </div>
  );
};

export default ModalManagerPortal;
